/**
 * Retorna o texto completo apenas quando o elemento está visualmente truncado (ellipsis).
 */
export function resolveEllipsisTooltip(
  element: Pick<HTMLElement, 'scrollWidth' | 'clientWidth'>,
  text: string | null | undefined,
): string | null {
  if (!text) return null;
  return element.scrollWidth > element.clientWidth ? text : null;
}
